import { Record } from 'immutable';
import { convertRawValues } from '../lib/utils/record_utils';

export default class GeneralLedgerRecord extends Record({
  id: null,
  _type: '',
  pending: false,
  amount: '',
  booking_date: '',
  entry_type: '',
  general_ledger_account: '',
  transaction_entry_id: null,
}) {
  constructor(data) {
    data = convertRawValues(data);
    super(data);
  }
}
